import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cp-base-notification',
  templateUrl: './base-notification.component.html',
  styleUrls: ['./base-notification.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class BaseNotificationComponent {
  @Input() public wrapperClassName = 'base';
  @Input() public contentClassName = 'base';
}
